import React from "react";

import styled from "styled-components";
import projectImg from "../../img/livebetting.jpg";
import { Link } from "gatsby";

const ProjectCard = (props) => {
  return (
    <CardContainer>
      <CardContent>
        <CardImage image={projectImg}></CardImage>
        <CardContentTitle to={props.to}>
          <h2>Live Betting Application </h2>
        </CardContentTitle>
        <CardContentSubTitle>
          The live sports streaming application developed by Scrumanac gives a
          unique life experience of streaming favorite sports events.
        </CardContentSubTitle>
      </CardContent>
      {/* {props.children} */}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  display: flex;
  z-index: 1;
  flex-direction: row;
  width: 30%;
  flex-basis: 30%;
  height: 200px;
  background: #fff;
  @media (max-width: 990px) {
    width: 100%;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const CardImage = styled.img.attrs((props) => ({
  src: props.image,
}))`
  width: 100%;
  object-fit: cover;
  height: 60%;
`;
const CardContentTitle = styled(Link).attrs((props) => ({
  to: props.to,
}))`
  font-family: 'Archivo';
  font-weight: 700;
  font-size: 1rem;
  line-height: 1rem;
  color: #3d3d3d;
  padding: 1rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;

  & h2 {
    font-weight: 700;
  }
`;
const CardContentSubTitle = styled.p`
  font-size: 1rem;
  line-height: 1.25rem;
  color: #3d3d3d;
  font-weight: 400;
  padding-bottom: 1rem;
  margin-bottom: 0;
  padding-left: 1rem;
  padding-right: 1rem;
`;

export default ProjectCard;
